/* qentle theme -- interactions
   Cart drawer (AJAX), product gallery, packs/variants, accordions, layer stack,
   band slideshow, review carousel, size modal, sticky add to cart, mobile nav. */
(function () {
  'use strict';

  var S = window.qentleSettings || {};
  var routes = S.routes || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart' };

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function addSwipe(el, cb) {
    if (!el) return;
    var sx = 0, sy = 0, touching = false, mx = null;
    el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; touching = true; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (!touching) return; touching = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.2) { el.__qSwiped = Date.now(); cb(dx < 0 ? 1 : -1); }
    }, { passive: true });
    el.addEventListener('mousedown', function (e) { if (e.button === 0) mx = e.clientX; });
    el.addEventListener('mouseup', function (e) {
      if (mx === null) return;
      var dx = e.clientX - mx; mx = null;
      if (Math.abs(dx) > 60) { el.__qSwiped = Date.now(); cb(dx < 0 ? 1 : -1); }
    });
  }
  function justSwiped(el) { return el && el.__qSwiped && Date.now() - el.__qSwiped < 450; }

  function formatMoney(cents) {
    var fmt = S.moneyFormat || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    if (fmt.indexOf('amount_with_comma_separator') > -1 || fmt.indexOf('amount_no_decimals_with_comma') > -1) {
      value = value.replace('.', ',');
    }
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var items = $$('.q-reveal');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('[data-q-header]');
    if (!header) return;
    var transparent = header.getAttribute('data-transparent') === 'true';
    function update() {
      var scrolled = window.scrollY > 30;
      if (!transparent) { header.classList.add('q-header--solid'); return; }
      header.classList.toggle('q-header--solid', scrolled);
      header.classList.toggle('q-header--transparent', !scrolled);
      $$('[data-logo-light]', header).forEach(function (el) { el.classList.toggle('is-hidden', scrolled); });
      $$('[data-logo-dark]', header).forEach(function (el) { el.classList.toggle('is-hidden', !scrolled); });
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    // mobile menu is handled by the inline script in sections/header.liquid
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    $$('[data-q-accordion]').forEach(function (acc) {
      var single = acc.getAttribute('data-single') !== 'false';
      $$('[data-q-accordion-trigger]', acc).forEach(function (btn) {
        on(btn, 'click', function () {
          var item = btn.closest('.q-accordion__item');
          var open = item.classList.contains('is-open');
          if (single) $$('.q-accordion__item', acc).forEach(function (i) { i.classList.remove('is-open'); setSign(i, false); });
          item.classList.toggle('is-open', !open);
          setSign(item, !open);
        });
      });
    });
    function setSign(item, open) {
      var sign = $('.q-accordion__sign', item);
      if (sign) sign.textContent = open ? '\u2212' : '+';
    }
  }

  /* ---------- layer stack ---------- */
  function initLayers() {
    $$('[data-q-layers]').forEach(function (root) {
      var plates = $$('[data-q-layer-plate]', root);
      var rows = $$('[data-q-layer-row]', root);
      var count = Math.max(plates.length, rows.length);
      if (!count) return;
      var idx = 0, timer = null;
      var interval = parseInt(root.getAttribute('data-interval') || '4000', 10);
      function paint() {
        plates.forEach(function (p, i) {
          p.classList.toggle('is-active', i === idx);
          var z = (count - 1 - i) * 62 + (i === idx ? 34 : 0);
          p.style.transform = 'rotateX(58deg) rotateZ(-45deg) translate3d(0, 0, ' + z + 'px)';
        });
        rows.forEach(function (r, i) { r.classList.toggle('is-active', i === idx); });
      }
      function start() { stop(); if (interval > 0) timer = setInterval(function () { idx = (idx + 1) % count; paint(); }, interval); }
      function stop() { if (timer) clearInterval(timer); }
      var scrubVid = root.querySelector('video[data-q-scrub]');
      rows.concat(plates).forEach(function (el, i) {
        on(el, 'click', function () {
          idx = i % count; paint(); start();
          if (scrubVid && scrubVid.__qScrubSeek) scrubVid.__qScrubSeek((idx + 0.75) / count);
        });
      });
      paint(); start();
    });
  }

  /* ---------- band slideshow ---------- */
  function initBands() {
    $$('[data-q-band]').forEach(function (root) {
      var slides = $$('[data-q-band-slide]', root);
      var dots = $$('[data-q-band-dot]', root);
      if (slides.length < 2) return;
      var idx = 0, timer = null;
      var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
      function paint() {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      function start() { stop(); if (interval > 0) timer = setInterval(function () { idx = (idx + 1) % slides.length; paint(); }, interval); }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d, i) { on(d, 'click', function () { idx = i; paint(); start(); }); });
      paint(); start();
    });
  }

  /* ---------- review carousel ---------- */
  function initCarousels() {
    $$('[data-q-carousel]').forEach(function (root) {
      var track = $('[data-q-carousel-track]', root);
      var prev = $('[data-q-carousel-prev]', root);
      var next = $('[data-q-carousel-next]', root);
      if (!track) return;
      var idx = 0;
      function perView() {
        var w = window.innerWidth;
        return w <= 640 ? 1 : (w <= 900 ? 2 : 3);
      }
      function max() { return Math.max(0, track.children.length - perView()); }
      function paint() {
        idx = Math.min(idx, max());
        var slide = track.children[0];
        var step = slide ? slide.getBoundingClientRect().width + 22 : 0;
        track.style.transform = 'translateX(-' + (idx * step) + 'px)';
        if (prev) prev.disabled = idx === 0;
        if (next) next.disabled = idx >= max();
      }
      var auto = parseInt(root.getAttribute('data-autoplay') || '0', 10);
      var timer = null;
      function start() { if (timer) clearInterval(timer); if (auto > 0) timer = setInterval(function () { idx = idx >= max() ? 0 : idx + 1; paint(); }, auto); }
      on(prev, 'click', function () { idx = Math.max(0, idx - 1); paint(); start(); });
      on(next, 'click', function () { idx = Math.min(max(), idx + 1); paint(); start(); });
      window.addEventListener('resize', paint);
      paint(); start();
    });
  }

  /* ---------- modals ---------- */
  function initModals() {
    $$('[data-q-modal-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        var m = document.getElementById(btn.getAttribute('data-q-modal-open'));
        if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      });
    });
    $$('[data-q-modal]').forEach(function (m) {
      function close() { m.classList.remove('is-open'); document.body.style.overflow = ''; }
      on(m, 'click', function (e) { if (e.target === m || e.target.hasAttribute('data-q-modal-close')) close(); });
      $$('[data-q-modal-close]', m).forEach(function (b) { on(b, 'click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- product ---------- */
  function initProduct() {
    var root = $('[data-q-product]');
    if (!root) return;

    /* gallery */
    var track = $('[data-q-gallery-track]', root);
    var thumbs = $$('[data-q-gallery-thumb]', root);
    var gIdx = 0;
    function paintGallery() {
      if (!track) return;
      var count = track.children.length;
      gIdx = (gIdx + count) % count;
      track.style.transform = 'translateX(-' + (gIdx * 100) + '%)';
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === gIdx); });
    }
    on($('[data-q-gallery-prev]', root), 'click', function () { gIdx--; paintGallery(); });
    on($('[data-q-gallery-next]', root), 'click', function () { gIdx++; paintGallery(); });
    thumbs.forEach(function (t, i) { on(t, 'click', function () { gIdx = i; paintGallery(); }); });
    paintGallery();

    /* swipe on the gallery (touch + mouse drag) */
    var galleryEl = $('.q-gallery', root);
    addSwipe(galleryEl, function (d) { gIdx += d; paintGallery(); });

    /* fullscreen lightbox */
    (function () {
      var box = $('[data-q-lightbox]');
      if (!box || !track) return;
      var imgs = $$('.q-gallery__slide img', root);
      if (!imgs.length) return;
      var stage = $('[data-q-lightbox-stage]', box);
      var stageImg = $('[data-q-lightbox-img]', box);
      var countEl = $('[data-q-lightbox-count]', box);
      var lIdx = 0, zoomed = false;
      function setZoom(z, x, y) {
        zoomed = z;
        box.classList.toggle('is-zoomed', z);
        if (stageImg) stageImg.style.transformOrigin = z && x != null ? x + '% ' + y + '%' : 'center center';
      }
      function paintBox() {
        lIdx = (lIdx + imgs.length) % imgs.length;
        stageImg.src = imgs[lIdx].currentSrc || imgs[lIdx].src;
        if (countEl) countEl.textContent = (lIdx + 1) + ' / ' + imgs.length;
        setZoom(false);
      }
      function openBox(i) { lIdx = i; paintBox(); box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      function closeBox() { box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; setZoom(false); }
      imgs.forEach(function (im, i) {
        on(im, 'click', function () { if (justSwiped(galleryEl)) return; openBox(i); });
      });
      on($('[data-q-gallery-open]', root), 'click', function () {
        var slide = track.children[gIdx];
        var im = slide ? slide.querySelector('img') : null;
        var i = im ? imgs.indexOf(im) : 0;
        openBox(i >= 0 ? i : 0);
      });
      on($('[data-q-lightbox-close]', box), 'click', closeBox);
      on($('[data-q-lightbox-prev]', box), 'click', function (e) { e.stopPropagation(); lIdx--; paintBox(); });
      on($('[data-q-lightbox-next]', box), 'click', function (e) { e.stopPropagation(); lIdx++; paintBox(); });
      on(stageImg, 'click', function (e) {
        if (justSwiped(stage)) return;
        e.stopPropagation();
        var r = stageImg.getBoundingClientRect();
        setZoom(!zoomed, ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      });
      on(stageImg, 'mousemove', function (e) {
        if (!zoomed) return;
        var r = stage.getBoundingClientRect();
        stageImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      on(stage, 'click', function (e) { if (e.target === stage) closeBox(); });
      addSwipe(stage, function (d) { if (zoomed) return; lIdx += d; paintBox(); });
      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeBox();
        if (e.key === 'ArrowLeft') { lIdx--; paintBox(); }
        if (e.key === 'ArrowRight') { lIdx++; paintBox(); }
      });
    })();
    var thumbRow = $('[data-q-thumbs]', root);
    on($('[data-q-thumbs-prev]', root), 'click', function () { if (thumbRow) thumbRow.scrollBy({ left: -thumbRow.clientWidth * 0.8, behavior: 'smooth' }); });
    on($('[data-q-thumbs-next]', root), 'click', function () { if (thumbRow) thumbRow.scrollBy({ left: thumbRow.clientWidth * 0.8, behavior: 'smooth' }); });

    /* variant + pack selection */
    var variantsEl = $('[data-q-variants]', root);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var state = {};
    $$('[data-q-option]', root).forEach(function (b) {
      if (b.classList.contains('is-active')) state[b.getAttribute('data-pos') || (b.getAttribute('data-q-option') === 'color' ? 1 : 2)] = b.getAttribute('data-value');
    });
    var activePack = $('[data-q-pack].is-active', root);
    if (activePack) {
      root.setAttribute('data-pack-qty', activePack.getAttribute('data-qty') || '1');
      var q0 = $('[data-q-quantity]', root);
      if (q0) q0.value = activePack.getAttribute('data-qty') || '1';
    }
    var idInput = $('[data-q-variant-id]', root);
    var atcButtons = $$('[data-q-atc]', root);
    var priceEls = $$('[data-q-price]', root);

    function currentVariant() {
      return variants.filter(function (v) {
        for (var p in state) { if (state[p] && v['option' + p] !== state[p]) return false; }
        return true;
      })[0];
    }
    function paintVariant() {
      var v = currentVariant();
      if (idInput && v) idInput.value = v.id;
      var qty = parseInt(root.getAttribute('data-pack-qty') || '1', 10);
      var ap = $('[data-q-pack].is-active', root);
      var packOverride = ap ? (ap.getAttribute('data-price') || '') : '';
      atcButtons.forEach(function (b) {
        var available = v && v.available;
        b.disabled = !available;
        var label = b.getAttribute('data-label') || (window.qentleStrings && window.qentleStrings.addToCart) || 'Add to cart';
        var priceText = packOverride || (v ? formatMoney(v.price * qty) : '');
        b.textContent = available ? (label + (priceText ? ' \u00b7 ' + priceText : '')) : ((window.qentleStrings && window.qentleStrings.soldOut) || 'Sold out');
      });
      priceEls.forEach(function (el) { if (v) el.textContent = packOverride || formatMoney(v.price * qty); });
      var stickyPrice = packOverride || (v ? formatMoney(v.price * qty) : '');
      $$('[data-q-sticky-price]').forEach(function (el) { el.textContent = stickyPrice; });
      $$('[data-q-option="size"]', root).forEach(function (b) {
        var pos = b.getAttribute('data-pos') || 2;
        var val = b.getAttribute('data-value');
        var ok = variants.some(function (vv) {
          if (!vv.available || vv['option' + pos] !== val) return false;
          for (var p in state) { if (p != pos && state[p] && vv['option' + p] !== state[p]) return false; }
          return true;
        });
        b.classList.toggle('is-unavailable', !ok);
        b.disabled = !ok;
      });
    }

    $$('[data-q-option]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        if (btn.classList.contains('is-disabled')) return;
        var which = btn.getAttribute('data-q-option');
        var value = btn.getAttribute('data-value');
        state[btn.getAttribute('data-pos') || (which === 'color' ? 1 : 2)] = value;
        $$('[data-q-option="' + which + '"]', root).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var out = $('[data-q-option-selected="' + which + '"]', root);
        if (out) out.textContent = value;
        paintVariant();
      });
    });

    $$('[data-q-pack]', root).forEach(function (packEl) {
      on(packEl, 'click', function () {
        $$('[data-q-pack]', root).forEach(function (p) { p.classList.toggle('is-active', p === packEl); });
        root.setAttribute('data-pack-qty', packEl.getAttribute('data-qty') || '1');
        var q = $('[data-q-quantity]', root);
        if (q) q.value = packEl.getAttribute('data-qty') || '1';
        paintVariant();
      });
    });
    paintVariant();

    /* mixed sizes: one row per pair, each becoming its own cart line */
    var mix = $('[data-q-mix]', root);
    if (mix) {
      var mixRows = $('[data-q-mix-rows]', mix);
      var mixNote = $('[data-q-mix-note]', mix);
      var mixToggle = $('[data-q-mix-toggle]', mix);
      var pairLabel = mix.getAttribute('data-pair-label') || 'Perechea';
      function sizeValues() {
        return $$('[data-q-option="size"]', root).map(function (b) { return b.getAttribute('data-value'); });
      }
      function baseSize() {
        var active = $('[data-q-option="size"].is-active', root);
        return active ? active.getAttribute('data-value') : (sizeValues()[0] || '');
      }
      function sizePos() {
        var b = $('[data-q-option="size"]', root);
        return b ? (b.getAttribute('data-pos') || '2') : '2';
      }
      function variantFor(size) {
        var want = {};
        for (var p in state) want[p] = state[p];
        want[sizePos()] = size;
        return variants.filter(function (v) {
          for (var p in want) { if (want[p] && v['option' + p] !== want[p]) return false; }
          return true;
        })[0];
      }
      function renderMix() {
        var n = parseInt(root.getAttribute('data-pack-qty') || '1', 10);
        var values = sizeValues();
        if (!values.length || n < 2) { mix.style.display = 'none'; return; }
        mix.style.display = '';
        var prev = $$('select', mixRows).map(function (s) { return s.value; });
        mixRows.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var row = document.createElement('label');
          row.className = 'q-mix__row';
          var span = document.createElement('span');
          span.className = 'q-mix__rowlabel';
          span.textContent = pairLabel + ' ' + (i + 1);
          var sel = document.createElement('select');
          sel.className = 'q-mix__select';
          values.forEach(function (val) {
            var v = variantFor(val);
            var opt = document.createElement('option');
            opt.value = val;
            opt.textContent = val + (v && !v.available ? ' \u2014 ausverkauft' : '');
            if (v && !v.available) opt.disabled = true;
            sel.appendChild(opt);
          });
          sel.value = prev[i] || baseSize() || values[0];
          if (sel.selectedIndex < 0) sel.selectedIndex = 0;
          row.appendChild(span);
          row.appendChild(sel);
          mixRows.appendChild(row);
        }
      }
      function setMix(on) {
        mix.classList.toggle('is-on', on);
        if (mixToggle) mixToggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        mixRows.hidden = !on;
        if (mixNote) mixNote.hidden = !on;
        if (on) renderMix();
      }
      on(mixToggle, 'click', function () { setMix(!mix.classList.contains('is-on')); });
      $$('[data-q-pack]', root).forEach(function (p) {
        on(p, 'click', function () { if (mix.classList.contains('is-on')) renderMix(); });
      });
      $$('[data-q-option="size"]', root).forEach(function (b) {
        on(b, 'click', function () { if (mix.classList.contains('is-on')) renderMix(); });
      });
      mix.qBuildItems = function () {
        var rows = $$('select', mixRows);
        if (!rows.length) return null;
        var activePack = $('[data-q-pack].is-active', root);
        var setName = activePack ? (activePack.querySelector('.q-tier__label') || {}).textContent : '';
        var bundleId = 'qs-' + Date.now().toString(36);
        var counts = {};
        rows.forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
        var items = [];
        for (var size in counts) {
          var v = variantFor(size);
          if (!v) return null;
          items.push({
            id: v.id,
            quantity: counts[size],
            properties: { _set: (setName || '').trim(), _bundle: bundleId }
          });
        }
        return items;
      };
      renderMix();
      setMix(false);
    }

    /* PDP scroll choreography: the gallery is pinned while the right column (title, sizes,
       packs, add to cart, details) scrolls past it. The grid keeps its natural height, so the
       gallery is carried up at the end and both columns finish flush with each other. */
    var pdpGrid = $('.q-product', root);
    var colLeft = $('.q-pdp-left-sticky', root);

    function measurePdp() {
      if (!pdpGrid || !colLeft) return;
      pdpGrid.style.minHeight = '';
      if (window.innerWidth < 990) { colLeft.style.top = ''; return; }
      var header = document.querySelector('.q-header');
      var top = (header ? Math.round(header.getBoundingClientRect().height) : 62) + 22;
      colLeft.style.top = top + 'px';
    }

    if (pdpGrid && colLeft) {
      window.addEventListener('resize', measurePdp);
      window.addEventListener('load', measurePdp);
      measurePdp();
      setTimeout(measurePdp, 700);
    }

    /* sticky bar */
    var sticky = $('[data-q-sticky]');
    if (sticky) {
      var mainAtc = $('[data-q-atc]', root);
      function paintStickyBar() {
        if (!mainAtc) { sticky.classList.remove('is-visible'); return; }
        var r = mainAtc.getBoundingClientRect();
        /* nur sichtbar, wenn der Haupt-Button komplett nach oben aus dem Bild gescrollt ist */
        sticky.classList.toggle('is-visible', r.bottom < 0);
      }
      window.addEventListener('scroll', paintStickyBar, { passive: true });
      window.addEventListener('resize', paintStickyBar);
      paintStickyBar();
    }
  }

  /* ---------- cart ---------- */
  var qLockY = 0;
  function lockScroll() {
    qLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -qLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, qLockY);
    html.style.scrollBehavior = prev;
  }
  function openDrawer() {
    var d = $('[data-q-cart-drawer]'), b = $('[data-q-cart-backdrop]');
    if (!d) return;
    d.classList.add('is-open'); if (b) b.classList.add('is-open');
    lockScroll();
    if (typeof fitShipMsg === 'function') setTimeout(fitShipMsg, 30);
  }
  function closeDrawer() {
    var d = $('[data-q-cart-drawer]'), b = $('[data-q-cart-backdrop]');
    if (d) d.classList.remove('is-open');
    if (b) b.classList.remove('is-open');
    unlockScroll();
  }

  /* free gifts (qentle.ro): 2 pairs = laundry net CADOU; 3+1 (4 pairs) = laundry net + waterproof bag CADOU.
     Only the boxer counts as a pair; accessories bought separately never trigger gifts. */
  var BOXER_HANDLE = 'qentle-boxer';
  var GIFTS = [
    { id: 58939266695512, min: 2, paid: 'saculet-de-spalat-lenjerie' },        /* Săculeț de spălat - CADOU */
    { id: 58973006037336, min: 4, paid: 'saculet-impermeabil-de-calatorie' }   /* Săculeț impermeabil - CADOU */
  ];
  function isGift(id) { for (var i = 0; i < GIFTS.length; i++) { if (GIFTS[i].id === id) return true; } return false; }
  function qStore(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }
  /* If the customer already bought the accessory, that one becomes the gift (no duplicate).
     The gift remembers it (_paid) so it turns back into the paid item if the pairs drop again. */
  function syncGift() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var pairs = 0, boxers = [], gifts = {}, paid = {};
      cart.items.forEach(function (it) {
        if (isGift(it.variant_id)) {
          if (!gifts[it.variant_id]) gifts[it.variant_id] = { key: it.key, qty: 0, from: (it.properties || {})._paid };
          gifts[it.variant_id].qty += it.quantity;
        } else if (it.handle === BOXER_HANDLE) {
          pairs += it.quantity;
          boxers.push({ key: it.key, qty: it.quantity, id: it.variant_id });
        } else if (!paid[it.handle]) {
          paid[it.handle] = { key: it.key, qty: it.quantity, id: it.variant_id };
        }
      });
      /* 3+1 logic. Going UP to 3 pairs: the free 4th pair is added (same size as the latest pair).
         Going DOWN from 4 to 3: the free pair is removed too, so the cart drops to 2 pairs. */
      var prev = parseInt(qStore('qPairs') || '0', 10);
      if (pairs === 3 && boxers.length) {
        var up = {};
        if (prev >= 4) {
          var fv = qStore('qFreeVid'), target = null;
          boxers.forEach(function (b) { if (String(b.id) === fv && !target) target = b; });
          if (!target) { target = boxers[0]; boxers.forEach(function (b) { if (b.qty > target.qty) target = b; }); }
          up[target.key] = target.qty - 1;
          qStore('qPairs', '2'); qStore('qFreeVid', null);
        } else {
          up[boxers[0].key] = boxers[0].qty + 1;
          qStore('qPairs', '4'); qStore('qFreeVid', String(boxers[0].id));
        }
        return postJSON('/cart/update.js', { updates: up }).then(syncGift);
      }
      qStore('qPairs', String(pairs));
      if (pairs < 4) qStore('qFreeVid', null);
      var updates = {}, hasUpdates = false, toAdd = [];
      GIFTS.forEach(function (g) {
        var want = pairs >= g.min;
        var gl = gifts[g.id];
        var pl = paid[g.paid];
        if (want && !gl) {
          if (pl) {
            updates[pl.key] = pl.qty - 1; hasUpdates = true;
            toAdd.push({ id: g.id, quantity: 1, properties: { _paid: String(pl.id) } });
          } else {
            toAdd.push({ id: g.id, quantity: 1 });
          }
        } else if (want && gl && gl.qty !== 1) {
          updates[gl.key] = 1; hasUpdates = true;
        } else if (!want && gl) {
          updates[gl.key] = 0; hasUpdates = true;
          if (gl.from) toAdd.push({ id: parseInt(gl.from, 10), quantity: 1 });
        }
      });
      var p = Promise.resolve();
      if (hasUpdates) p = p.then(function () { return postJSON('/cart/update.js', { updates: updates }); });
      if (toAdd.length) p = p.then(function () { return postJSON('/cart/add.js', { items: toAdd }); });
      return p;
    }).catch(function () {});
  }

  /* keep the cart bar message on one line: shrink the font only if it would wrap */
  function fitShipMsg() {
    $$('.q-ship__msg').forEach(function (el) {
      el.style.fontSize = '';
      var fs = parseFloat(getComputedStyle(el).fontSize) || 15, n = 0;
      while (el.scrollWidth > el.clientWidth + 1 && fs > 10 && n < 30) { fs -= 0.5; el.style.fontSize = fs + 'px'; n++; }
    });
  }
  window.addEventListener('resize', fitShipMsg);

  function refreshCart() {
    return syncGift()
      .then(function () { return fetch(routes.cart + '?section_id=cart-drawer'); })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-q-cart-inner]');
        var current = $('[data-q-cart-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var pairCount = 0;
        cart.items.forEach(function (it) { if (!isGift(it.variant_id)) pairCount += it.quantity; });
        $$('[data-q-cart-count]').forEach(function (el) {
          el.textContent = pairCount;
          el.parentElement.style.display = pairCount > 0 ? '' : 'none';
        });
        bindCartEvents();
        fitShipMsg();
        return cart;
      });
  }

  function bindCartEvents() {
    $$('[data-q-cart-close]').forEach(function (btn) {
      if (btn.getAttribute('data-q-close-bound')) return;
      btn.setAttribute('data-q-close-bound', '1');
      on(btn, 'click', closeDrawer);
    });
    $$('.q-qty').forEach(function (box) {
      if (box.getAttribute('data-q-hint-bound')) return;
      box.setAttribute('data-q-hint-bound', '1');
      var locked = box.querySelectorAll('button[disabled]');
      if (!locked.length) return;
      var hint = document.createElement('span');
      hint.className = 'q-qty__hint';
      hint.textContent = box.getAttribute('data-hint') || 'Poți alege între 1 și 4 perechi.';
      box.appendChild(hint);
      var show = function () { box.classList.add('is-hinting'); };
      var hide = function () { box.classList.remove('is-hinting'); };
      Array.prototype.forEach.call(locked, function (b) {
        b.addEventListener('mouseenter', show);
        b.addEventListener('mouseleave', hide);
        b.addEventListener('focus', show);
        b.addEventListener('blur', hide);
        b.addEventListener('click', function () { show(); setTimeout(hide, 1800); });
        b.addEventListener('touchstart', function () { show(); setTimeout(hide, 1800); }, { passive: true });
      });
    });
    $$('[data-q-cart-remove-set]').forEach(function (btn) {
      if (btn.getAttribute('data-q-set-bound')) return;
      btn.setAttribute('data-q-set-bound', '1');
      on(btn, 'click', function () {
        var keys = (btn.getAttribute('data-keys') || '').split('~~').filter(Boolean);
        if (!keys.length) return;
        btn.disabled = true;
        /* line item keys are the only reliable address for /cart/update.js */
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        fetch(routes.cart_update || '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { refreshCart(); });
      });
    });
    $$('[data-q-upsell-add]').forEach(function (btn) {
      if (btn.getAttribute('data-q-ups-bound')) return;
      btn.setAttribute('data-q-ups-bound', '1');
      on(btn, 'click', function () {
        btn.disabled = true; btn.textContent = '\u2026';
        postJSON('/cart/add.js', { items: [{ id: parseInt(btn.getAttribute('data-q-upsell-add'), 10), quantity: 1 }] })
          .then(function () { return refreshCart(); })
          .catch(function () { btn.disabled = false; btn.textContent = 'Adaugă'; });
      });
    });
    $$('[data-q-cart-change]').forEach(function (btn) {
      on(btn, 'click', function () {
        var line = btn.getAttribute('data-line');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        if (isNaN(qty)) qty = 0;
        if (qty < 0) qty = 0;
        fetch(routes.cart_change, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        }).then(refreshCart);
      });
    });
  }

  function initCart() {
    $$('[data-q-cart-toggle]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        if (S.cartType !== 'drawer') return;
        e.preventDefault();
        openDrawer();
      });
    });
    $$('[data-q-cart-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
    on($('[data-q-cart-backdrop]'), 'click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    bindCartEvents();

    $$('[data-q-add-form]').forEach(function (form) {
      on(form, 'submit', function (e) {
        if (S.cartType !== 'drawer') return;
        e.preventDefault();
        var btn = $('[data-q-atc]', form);
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '\u2026'; }
        var mixEl = document.querySelector('[data-q-mix].is-on');
        var mixItems = mixEl && mixEl.qBuildItems ? mixEl.qBuildItems() : null;
        var request = mixItems && mixItems.length
          ? fetch(routes.cart_add, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: mixItems })
            })
          : fetch(routes.cart_add, { method: 'POST', headers: { Accept: 'application/javascript' }, body: new FormData(form) });
        request
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message);
            return refreshCart();
          })
          .then(function () { openDrawer(); })
          .catch(function (err) {
            var slot = $('[data-q-form-error]', form);
            if (slot) slot.textContent = err.message || (window.qentleStrings && window.qentleStrings.cartError);
          })
          .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
      });
    });
  }

  /* ---------- autoplay video ---------- */
  function initVideos() {
    $$('video[data-q-autoplay]').forEach(function (v) {
      v.muted = true; v.defaultMuted = true;
      var tries = 0;
      var t = setInterval(function () {
        if (v.paused) v.play().catch(function () {});
        if (++tries > 12 || !v.paused) clearInterval(t);
      }, 250);
    });
  }

  function initTicker() {
    $$('[data-q-ticker]').forEach(function (root) {
      if (root.getAttribute('data-behaviour') === 'arrows') {
        var lines = $$('[data-q-ticker-line]', root);
        if (!lines.length) return;
        var i = 0;
        function paint() { lines.forEach(function (l, k) { l.classList.toggle('is-shown', k === i); }); }
        $$('[data-q-ticker-step]', root).forEach(function (btn) {
          on(btn, 'click', function () {
            var d = parseInt(btn.getAttribute('data-q-ticker-step'), 10) || 1;
            i = (i + d + lines.length) % lines.length;
            paint();
          });
        });
        paint();
      }
    });
  }

  function initPreloader() {
    var pre = $('[data-q-preloader]');
    if (!pre) return;
    var dur = parseInt(pre.getAttribute('data-duration') || '1000', 10);
    setTimeout(function () { pre.classList.add('is-done'); }, dur);
    setTimeout(function () { if (pre.parentNode) pre.parentNode.removeChild(pre); }, dur + 900);
  }

  function initScrubVideos() {
    $$('video[data-q-scrub]').forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      var root = v.closest('[data-q-scrub-root]') || v;
      var duration = 0, target = 0, current = -1, primed = false;
      var range = parseFloat(v.getAttribute('data-q-scrub-range') || '100') / 100;
      var manualUntil = 0;
      function prime() {
        if (primed || !duration) return;
        primed = true;
        // one silent play/pause unlocks seeking on iOS/Safari
        var p = v.play();
        if (p && p.then) p.then(function () { v.pause(); v.currentTime = 0; }).catch(function () {});
        else { v.pause(); v.currentTime = 0; }
      }
      function onMeta() { duration = v.duration || 0; prime(); }
      if (v.readyState >= 1) onMeta();
      v.addEventListener('loadedmetadata', onMeta);
      v.addEventListener('canplay', function () { duration = v.duration || duration; prime(); });
      try { v.load(); } catch (e) {}
      /* scroll scrubbing removed: video responds only to drag and layer clicks */
      /* manual control: click a layer row (seek) or drag across the video (scrub) */
      function seekFrac(f) {
        if (!duration) { v.addEventListener('loadedmetadata', function () { seekFrac(f); }, { once: true }); return; }
        if (f < 0) f = 0; if (f > 1) f = 1;
        target = f * Math.max(0, duration * range - 0.05);
        manualUntil = Date.now() + 4000;
      }
      v.__qScrubSeek = seekFrac;
      var dragX = null, dragStart = 0;
      root.addEventListener('pointerdown', function (e) { dragX = e.clientX; dragStart = target; prime(); });
      window.addEventListener('pointermove', function (e) {
        if (dragX === null || !duration) return;
        var w = root.getBoundingClientRect().width || 1;
        var span = Math.max(0, duration * range - 0.05);
        var t = dragStart + ((e.clientX - dragX) / w) * span * 1.4;
        if (t < 0) t = 0; if (t > span) t = span;
        target = t;
        manualUntil = Date.now() + 4000;
      });
      window.addEventListener('pointerup', function () { dragX = null; });
      /* cursor hint so customers know the video is draggable */
      var hint = document.createElement('div');
      hint.className = 'q-scrub-hint';
      hint.textContent = root.getAttribute('data-q-scrub-hint') || 'Ziehen';
      root.appendChild(hint);
      root.addEventListener('mousemove', function (e) {
        var r = root.getBoundingClientRect();
        hint.style.left = (e.clientX - r.left) + 'px';
        hint.style.top = (e.clientY - r.top) + 'px';
      });
      root.addEventListener('mouseenter', function () { hint.classList.add('is-visible'); });
      root.addEventListener('mouseleave', function () { hint.classList.remove('is-visible'); });
      (function tick() {
        if (duration && v.readyState >= 2 && !v.seeking) {
          if (current < 0) current = target;
          current += (target - current) * 0.09;
          if (Math.abs(current - v.currentTime) > 0.01) {
            try { v.currentTime = current; } catch (e) {}
          }
        }
        requestAnimationFrame(tick);
      })();
    });
  }

  function init() {
    initScrubVideos();
    initReveal(); initHeader(); initTicker(); initAccordions(); initLayers(); initBands();
    initCarousels(); initModals(); initProduct(); initCart(); initVideos();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);

  /* ---------- size advisor ---------- */
  window.qentleCart = { refresh: refreshCart, open: openDrawer, close: closeDrawer };

  function initAdvisor() {
    var drawer = $('[data-q-adv]');
    if (!drawer || drawer.getAttribute('data-init')) return;
    drawer.setAttribute('data-init', '1');
    var backdrop = $('[data-q-adv-backdrop]');
    var sizes = [
      { s: 'S', min: 79, max: 84 },
      { s: 'M', min: 85, max: 90 },
      { s: 'L', min: 91, max: 96 },
      { s: 'XL', min: 97, max: 102 },
      { s: 'XXL', min: 103, max: 108 }
    ];
    var state = { step: 0, waist: 90, size: 'M', qty: 3 };

    function setOpen(o) {
      drawer.classList.toggle('is-open', o);
      if (backdrop) backdrop.classList.toggle('is-open', o);
      document.body.style.overflow = o ? 'hidden' : '';
    }
    $$('[data-q-adv-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); setOpen(true); paint(); }); });
    $$('[data-q-adv-close]', drawer).forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
    on(backdrop, 'click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });

    function calcSize() {
      var w = state.waist;
      var hit = sizes[0].s;
      for (var i = 0; i < sizes.length; i++) { if (w >= sizes[i].min) hit = sizes[i].s; }
      if (w > sizes[sizes.length - 1].max) hit = sizes[sizes.length - 1].s;
      state.size = hit;
    }
    function findVariant() {
      var el = document.querySelector('[data-q-variants]');
      if (!el) return null;
      var variants = [];
      try { variants = JSON.parse(el.textContent); } catch (e) { return null; }
      var exact = variants.filter(function (v) { return v.available && (v.option1 === state.size || v.option2 === state.size || v.option3 === state.size); })[0];
      return exact || null;
    }
    function paint() {
      calcSize();
      $$('[data-q-adv-step]', drawer).forEach(function (st, i) { st.classList.toggle('is-active', i === state.step); });
      $$('[data-q-adv-dot]', drawer).forEach(function (d, i) { d.classList.toggle('is-active', i <= state.step); });
      var out = $('[data-q-adv-waist-out]', drawer);
      if (out) out.textContent = state.waist + ' cm';
      var res = $('[data-q-adv-size]', drawer);
      if (res) res.textContent = state.size;
      var rangeInfo = $('[data-q-adv-range]', drawer);
      if (rangeInfo) {
        var def = null;
        for (var i = 0; i < sizes.length; i++) { if (sizes[i].s === state.size) def = sizes[i]; }
        rangeInfo.textContent = def ? ('Talie ' + def.min + '–' + def.max + ' cm') : '';
      }
      var v = findVariant();
      var avail = $('[data-q-adv-avail]', drawer);
      if (avail) avail.style.display = v ? 'none' : 'block';
      $$('[data-q-adv-qty]', drawer).forEach(function (b) { b.classList.toggle('is-active', parseInt(b.getAttribute('data-qty'), 10) === state.qty); });
      var sum = $('[data-q-adv-summary]', drawer);
      if (sum) sum.textContent = state.qty + ' perechi \u00b7 M\u0103rime ' + state.size;
      var sq = $('[data-q-adv-sumqty]', drawer);
      if (sq) sq.textContent = 'x' + state.qty;
      var back = $('[data-q-adv-back]', drawer);
      if (back) back.style.display = state.step === 0 ? 'none' : '';
      var next = $('[data-q-adv-next]', drawer);
      if (next) next.textContent = state.step === 2 ? next.getAttribute('data-atc-label') : next.getAttribute('data-next-label');
    }
    var slider = $('[data-q-adv-slider]', drawer);
    var number = $('[data-q-adv-number]', drawer);
    function setWaist(v) {
      v = parseInt(v, 10);
      if (isNaN(v)) return;
      state.waist = Math.max(70, Math.min(118, v));
      if (slider) slider.value = state.waist;
      if (number) number.value = state.waist;
      paint();
    }
    on(slider, 'input', function () { setWaist(slider.value); });
    on(number, 'input', function () { setWaist(number.value); });
    $$('[data-q-adv-qty]', drawer).forEach(function (b) {
      on(b, 'click', function () { state.qty = parseInt(b.getAttribute('data-qty'), 10) || 1; paint(); });
    });
    on($('[data-q-adv-back]', drawer), 'click', function () { if (state.step > 0) { state.step--; paint(); } });
    on($('[data-q-adv-next]', drawer), 'click', function () {
      if (state.step < 2) { state.step++; paint(); return; }
      var v = findVariant();
      var err = $('[data-q-adv-error]', drawer);
      if (!v) { if (err) err.textContent = (window.qentleStrings && window.qentleStrings.soldOut) || 'Nicht verf\u00fcgbar'; return; }
      var btn = $('[data-q-adv-next]', drawer);
      btn.disabled = true;
      fetch((S.routes || {}).cart_add || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: state.qty })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        setOpen(false);
        state.step = 0;
        return refreshCart().then(function () { openDrawer(); });
      }).catch(function (e) {
        if (err) err.textContent = e.message || (window.qentleStrings && window.qentleStrings.cartError) || 'Fehler';
      }).finally(function () { btn.disabled = false; });
    });
    paint();
  }
  if (document.readyState !== 'loading') initAdvisor();
  else document.addEventListener('DOMContentLoaded', initAdvisor);
  document.addEventListener('shopify:section:load', initAdvisor);
})();

/* Footer: aufklappbare Menüspalten (nur mobil aktiv) */
(function () {
  var cols = document.querySelectorAll('[data-q-fcol].q-footer__col--collapsible');
  Array.prototype.forEach.call(cols, function (col) {
    var btn = col.querySelector('[data-q-fcol-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (window.innerWidth > 749) return;
      var open = col.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();